import React, { useContext, useEffect, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { FiX } from "react-icons/fi";

export const AboutYou = () => {

    const { BeURL, instructor, setInstructor } = useContext(DContext);

    const [form, setForm] = useState({
        bio: "",
        teachingStyle: "",
        specialization: []
    });

    const [specInput, setSpecInput] = useState("");
    const [loading, setLoading] = useState(false);

    // ================= PREFILL FROM CONTEXT =================
    useEffect(() => {
        if (instructor) {
            setForm({
                bio: instructor.bio || "",
                teachingStyle: instructor.teachingStyle || "",
                specialization: instructor.specialization || []
            });
        }
    }, [instructor]);

    // ================= HANDLE CHANGE =================
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // ================= SPECIALIZATION CHIP =================
    const addSpec = () => {
        if (!specInput.trim()) return;
        if (form.specialization.includes(specInput.trim())) return;

        setForm(prev => ({
            ...prev,
            specialization: [...prev.specialization, specInput.trim()]
        }));

        setSpecInput("");
    };

    const removeSpec = (s) => {
        setForm(prev => ({
            ...prev,
            specialization: prev.specialization.filter(i => i !== s)
        }));
    };

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const res = await fetch(`${BeURL}/update/instructor/profile/about`, {
                method: "PUT",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form)
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || "Update failed");
            }

            //Update context instantly
            setInstructor(data.updatedInstructor);

            alert("About You Updated Successfully");

        } catch (err) {
            console.error(err);
            alert(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-5xl bg-white p-6 rounded-xl shadow-sm">
            <h2 className="text-xl font-semibold mb-6">
                About You
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6">

                {/* BIO */}
                <div>
                    <label className="text-sm font-medium">Bio</label>
                    <textarea
                        name="bio"
                        rows="5"
                        value={form.bio}
                        onChange={handleChange}
                        className="w-full border px-3 py-2 rounded-lg mt-1"
                    />
                </div>

                {/* TEACHING STYLE */}
                <div>
                    <label className="text-sm font-medium">Teaching Style</label>
                    <textarea
                        name="teachingStyle"
                        rows="3"
                        value={form.teachingStyle}
                        onChange={handleChange}
                        className="w-full border px-3 py-2 rounded-lg mt-1"
                    />
                </div>

                {/* SPECIALIZATION */}
                <div>
                    <p className="text-sm font-medium mb-2">Specialization</p>

                    <div className="flex gap-2 flex-wrap mb-2">
                        {form.specialization.map((s) => (
                            <span
                                key={s}
                                className="flex items-center gap-1 bg-primary-600 text-white px-3 py-1 rounded-full text-xs"
                            >
                                {s}
                                <FiX
                                    onClick={() => removeSpec(s)}
                                    className="cursor-pointer"
                                />
                            </span>
                        ))}
                    </div>

                    <div className="flex gap-2">
                        <input
                            value={specInput}
                            onChange={(e) => setSpecInput(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    addSpec();
                                }
                            }}
                            placeholder="Add specialization"
                            className="border px-3 py-2 rounded-lg w-full"
                        />

                        <button
                            type="button"
                            onClick={addSpec}
                            className="bg-secondary-500 text-white px-4 rounded-lg"
                        >
                            Add
                        </button>
                    </div>
                </div>

                {/* SAVE */}
                <button
                    type="submit"
                    disabled={loading}
                    className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-lg"
                >
                    {loading ? "Saving..." : "Save About You"}
                </button>

            </form>
        </div>
    );
};
